var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClienti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165.39 200",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.69,
    cy: 46,
    r: 46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.26,200c15.44,0,25.65-16.04,19.13-30.04-17.79-38.15-53.93-64.58-80.69-64.58S19.79,131.81,2,169.96c-6.53,14,3.69,30.04,19.13,30.04h123.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClienti);
export default __webpack_public_path__ + "static/media/menu-clienti.10cb230ab307591bd59d302fd0cfdbf3.svg";
export { ForwardRef as ReactComponent };